import type { PageTemplate } from '@packages/recommendations/src/types';
import type { ParagraphType } from '../../../interfaces/components';
import { ComponentTypes } from '../../../interfaces/components';
import { ComponentRecognizer } from '../ComponentRecognizer/ComponentRecognizer';
import { registerFlexibleComponents } from '../ComponentRecognizer/registerFlexibleComponents';
import { CookieConsentManager } from '../CookieConsentManager/CookieConsentManager.client';
import { ClientRegistration } from './ClientRegistration.client';
import { RefreshContentAfterLogin } from './RefreshContentAfterLogin.client';

/**
 * Registers CMS flexible components for both server and client rendering, then
 * renders the given paragraphs. This is the only supported way to render CMS
 * paragraphs — it guarantees registration, so callers can't forget to wire it up.
 */
export const RegisteredCmsComponents = ({
  paragraphs = [],
  pageTemplate,
  token,
}: {
  /** array of all paragraphs that are to be rendered */
  paragraphs: ParagraphType[];
  /** current page you are on (needed for tracking purposes) */
  pageTemplate: PageTemplate;
  token?: string;
}) => {
  registerFlexibleComponents();
  let recoIndex = 0;

  return (
    <CookieConsentManager>
      <ClientRegistration />
      <RefreshContentAfterLogin />
      {paragraphs.map((p) => (
        <ComponentRecognizer
          key={p.id}
          item={p}
          pageTemplate={pageTemplate}
          // if this paragraph is a recoslider, pass the reco index and increase it after that
          {...((p.type as ComponentTypes) === ComponentTypes.RecoPrudsys && {
            // eslint-disable-next-line no-plusplus
            recoIndex: recoIndex++,
          })}
          token={token}
        />
      ))}
    </CookieConsentManager>
  );
};
